
import styles from "./PartWorkReport.module.scss";
import { useEffect, useState } from "react";
import PartWorkItemReport from './PartWorkItemReport/PartWorkItemReport';
import TestChangeForm from "components/Forms/TestForm/TestChangeForm";
import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
const PartWorkReport = ({title_dat, id, setRender, partWorkTests }) => {
 const componentRef = useRef();

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });
  const [edit_id, setEditId] = useState(null);

  const ChangeRowOn = (id) => {
    setEditId(id);
  }
  
  return (
    <>
    <button className={styles.btn_print} onClick={handlePrint}>Печать 🖨️ </button>
    <div ref={componentRef}  className={styles.test_card}>
      <div className={styles.div_print}><h4>Отчет по тесту: {title_dat} </h4><h4>Дата отчета: {new Date().toLocaleString("ru-RU")}</h4> </div>
      {partWorkTests.map((item, index) =>
        item.id !== edit_id ? (
          <>
          <PartWorkItemReport
            item={item}
            index={index}
            setRender={setRender}
            MassLength={partWorkTests.length}
            ChangeRowOn={ChangeRowOn}
          />
        
          </>
        ) : (
         <></>
          
        )
      )}


    </div >
    </>
  );
};

export default PartWorkReport;
